import { render } from "./Card.vue?vue&type=template&id=1671da4a&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=1671da4a&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1671da4a"]])

export default __exports__